module.exports = __webpack_public_path__ + "static/media/peugeoti.48f13a63.jpg";